require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-cdk-4-6-and-dna-repair-role-in-cancer.json") })
        }
      }, "path---research-cdk-4-6-and-dna-repair-role-in-cancer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-cdk-4-6-and-dna-repair-role-in-cancer!./.cache/json/research-cdk-4-6-and-dna-repair-role-in-cancer.json
// module id = 485
// module chunks = 231608221292675